import { IconSparkles } from '@tabler/icons-react'
import { ModalV2 } from './Common/ModalV2'
import { PageHeader } from './PageHeader'
import { useProjectStore } from 'store/useProjectStore'
import { useAuth } from 'util/auth'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useUpdateUser } from 'hooks/users'

export const OutcastRebrandModal = () => {
  const {
    showOutcastRebrandModal,
    setShowConfetti,
    setShowOutcastRebrandModal,
  } = useProjectStore()

  const { user } = useAuth()
  const { mutateAsync: updateUser } = useUpdateUser()

  const [hasLocallyDismissedModal, setHasLocallyDismissedModal] =
    useState(false)

  useEffect(() => {
    if (user && !hasLocallyDismissedModal && !user.hasSeenOutcastRebrandModal) {
      setShowConfetti(true)
      setShowOutcastRebrandModal(true)
      setHasLocallyDismissedModal(true)
    }
  }, [
    user,
    hasLocallyDismissedModal,
    setShowConfetti,
    setShowOutcastRebrandModal,
  ])

  const handleClose = async () => {
    if (user) {
      await updateUser({
        userId: user.id,
        data: {
          hasSeenOutcastRebrandModal: true,
        },
      })
    }
    setShowOutcastRebrandModal(false)
  }

  return (
    <ModalV2
      open={showOutcastRebrandModal}
      onClose={handleClose}
      className="flex flex-col"
      includeCloseButton
    >
      <PageHeader icon={IconSparkles} title="ToastyAI is now Outcast!​" />
      <div className="flex flex-col gap-4">
        <p>
          It’s the same great platform you love, but now with even more powerful
          tools and a sleek new identity. 🤖
        </p>
        <Link
          href="https://www.outcast.ai/changelog/"
          target="_blank"
          className="w-full rounded-md bg-toasty-blue-600 p-2 text-center text-sm font-bold text-white"
        >
          Learn More
        </Link>
      </div>
    </ModalV2>
  )
}
